import { GrowthModelDraftEdits } from '../../../models/growth-model/growth-model';

function isPlainObject(value: unknown): value is Record<string, unknown> {
	return !!value && typeof value === 'object' && !Array.isArray(value);
}

function sanitizeDraftEditsForApi(edits: GrowthModelDraftEdits | null | undefined): GrowthModelDraftEdits {
	const src = (edits || {}) as Record<string, unknown>;
	const next: GrowthModelDraftEdits = {};

	if (isPlainObject(src.inputs)) next.inputs = src.inputs as GrowthModelDraftEdits['inputs'];
	if (isPlainObject(src.rov)) next.rov = src.rov as GrowthModelDraftEdits['rov'];
	if (isPlainObject(src.mov)) next.mov = src.mov as GrowthModelDraftEdits['mov'];
	if (typeof src.cutoffIdx === 'number') next.cutoffIdx = src.cutoffIdx;
	if (typeof src.fyStart === 'number') next.fyStart = src.fyStart;
	if (typeof src.ccy === 'string') next.ccy = src.ccy;
	if (typeof src.amzCutoff === 'string') next.amzCutoff = src.amzCutoff;
	if (typeof src.rounding === 'string') next.rounding = src.rounding;
	if (typeof src.viewFrom === 'number') next.viewFrom = src.viewFrom;
	if (typeof src.viewTo === 'number') next.viewTo = src.viewTo;
	if (isPlainObject(src.rowCfg)) next.rowCfg = src.rowCfg as GrowthModelDraftEdits['rowCfg'];
	if (isPlainObject(src.rowOrd)) next.rowOrd = src.rowOrd as GrowthModelDraftEdits['rowOrd'];
	if (isPlainObject(src.rowDesc)) next.rowDesc = src.rowDesc as GrowthModelDraftEdits['rowDesc'];
	if (isPlainObject(src.scenarioOn)) next.scenarioOn = src.scenarioOn as GrowthModelDraftEdits['scenarioOn'];
	if (isPlainObject(src.drivers)) next.drivers = src.drivers as GrowthModelDraftEdits['drivers'];
	if (Array.isArray(src.deletedDrivers) && src.deletedDrivers.length) next.deletedDrivers = src.deletedDrivers.filter((k): k is string => typeof k === 'string');
	if (Array.isArray(src.scenarios)) next.scenarios = src.scenarios as GrowthModelDraftEdits['scenarios'];
	if (isPlainObject(src.productMix)) next.productMix = src.productMix as GrowthModelDraftEdits['productMix'];
	if (isPlainObject(src.sessionSources)) next.sessionSources = src.sessionSources as GrowthModelDraftEdits['sessionSources'];
	if (isPlainObject(src.cohortInput)) next.cohortInput = src.cohortInput as GrowthModelDraftEdits['cohortInput'];
	if (isPlainObject(src.cohortGuards)) next.cohortGuards = src.cohortGuards as GrowthModelDraftEdits['cohortGuards'];
	if (isPlainObject(src.cohortAuto)) next.cohortAuto = src.cohortAuto as GrowthModelDraftEdits['cohortAuto'];
	if (isPlainObject(src.flagReviews)) next.flagReviews = src.flagReviews as GrowthModelDraftEdits['flagReviews'];
	if (isPlainObject(src.overrideInfo)) next.overrideInfo = src.overrideInfo as GrowthModelDraftEdits['overrideInfo'];
	if (isPlainObject(src.mixInput)) next.mixInput = src.mixInput as GrowthModelDraftEdits['mixInput'];
	if (isPlainObject(src.cogsInput)) next.cogsInput = src.cogsInput as GrowthModelDraftEdits['cogsInput'];
	if (isPlainObject(src.srcInput)) next.srcInput = src.srcInput as GrowthModelDraftEdits['srcInput'];
	if (isPlainObject(src.cpsInput)) next.cpsInput = src.cpsInput as GrowthModelDraftEdits['cpsInput'];
	if (Array.isArray(src.overrides)) next.overrides = src.overrides as GrowthModelDraftEdits['overrides'];

	return next;
}

export { sanitizeDraftEditsForApi };
